import {ClientGeneralInformationDtoModel} from './client.general.information.dto.model';

export class ClientDtoModel {
    lastName?: string;
    firstName?: string;
    phoneNumber?: string;
    birthDate?: any;
    creationDate?: any;
    sponsorshipCode?: string;
    zipCode?: string;
    email?: string;
    sexe?: string;
    active?: boolean;
    darkMode?: boolean;
    uuid?: string;
    preferences?: string[];
    referredClient?: ClientGeneralInformationDtoModel[];
    subscribed?: boolean;
}
